module.exports = "<span> Web v{{vm.webVersion}} | API v{{vm.version}}</span>\n"